/* unplugin-vue-components disabled */import { render } from "./DashboardUsersTiles.vue?vue&type=template&id=1f82cdfa&scoped=true&ts=true"
import script from "./DashboardUsersTiles.vue?vue&type=script&lang=ts"
export * from "./DashboardUsersTiles.vue?vue&type=script&lang=ts"

import "./DashboardUsersTiles.vue?vue&type=style&index=0&id=1f82cdfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f82cdfa"]])

export default __exports__